import { css } from '@emotion/core';

export const userMenuMobileOverrideCSS = css`
    width: 100%;
    max-height: unset;
    border-radius: 0;
    box-shadow: none;
`;
